<script setup>
const props = defineProps({
  color: {
    type: String,
    default: 'gray',
    validator: value =>
      ['gray', 'green', 'red', 'blue', 'yellow', 'orange', 'purple'].includes(
        value
      ),
  },
  size: {
    type: String,
    default: 'medium',
    validator: value => ['small', 'medium', 'large'].includes(value),
  },
});

const colorClasses = {
  gray: 'bg-n-slate-3 text-n-slate-11 border-n-slate-6',
  green: 'bg-n-teal-3 text-n-teal-11 border-n-teal-6',
  red: 'bg-n-ruby-3 text-n-ruby-11 border-n-ruby-6',
  blue: 'bg-n-blue-3 text-n-blue-11 border-n-blue-6',
  yellow: 'bg-n-amber-3 text-n-amber-11 border-n-amber-6',
  orange: 'bg-n-orange-3 text-n-orange-11 border-n-orange-6',
  purple: 'bg-n-purple-3 text-n-purple-11 border-n-purple-6',
};

const sizeClasses = {
  small: 'text-xs px-2 py-0.5',
  medium: 'text-sm px-2.5 py-1',
  large: 'text-base px-3 py-1.5',
};
</script>

<template>
  <span
    class="inline-flex items-center font-medium rounded-full border"
    :class="[colorClasses[props.color], sizeClasses[props.size]]"
  >
    <slot />
  </span>
</template>
